import Vue from 'vue';
import Vuex from 'vuex';
import { createServerRootMixin } from 'vue-instantsearch';
// import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
// import aa from 'search-insights';
import VueObserveVisibility from 'vue-observe-visibility';
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter/src/TypesenseInstantsearchAdapter';

import * as routing from '../util/routing';
import { createStore } from '../catalog-store';
import { createRouter } from '../router';
import DjangoTranslations from '../plugins/DjangoTranslations';
import CurrencyFormatter from '../plugins/CurrencyFormatter';
import App from '../components/App.vue';

Vue.use(Vuex);
Vue.use(DjangoTranslations);
Vue.use(CurrencyFormatter);
Vue.use(VueObserveVisibility);

export async function createApp({ context, renderToString }) {
  const store = createStore(context);
  store.commit('setCatalogContext', context.catalogContext);

  if (typeof window === 'object') {
    // Connect favorite system to Vue app so that favorites
    // are updated automatically, even when this happens outside
    store.commit('setFavorites', window.favorite.getFavorites());
    window.favorite.addEventListener('update', e => {
      store.commit('setFavorites', e.detail);
    });
  }

  const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
      apiKey: store.state.typesense.searchAPIKey, // Be sure to use an API key that only allows search operations
      nodes: [
        {
          // TODO: put in config
          host: 'tori51mnjpx6d40sp-1.a1.typesense.net',
          port: '443',
          protocol: 'https',
        },
      ],
      cacheSearchResultsForSeconds: 2 * 60, // Cache search results from server. Defaults to 2 minutes. Set to 0 to disable caching.
    },
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    //  query_by is required.
    additionalSearchParameters: {
      query_by:
        'section_names,subcategory_names,title,brand_name,store_name,color',
      query_by_weights: '20,19,18,17,16,1', // ,1,1,3',
      // text_match_type: 'max_weight',
      sort_by:
        '_text_match(buckets: 6):desc,interaction_rate_rounded:desc,outlink_clicks_rounded:desc', //,favorites_rounded:desc
      // sort_by:
      //   '_text_match:desc,interaction_rate_rounded:desc,store_membership:desc,outlink_clicks_rounded:desc',
      // Only attributes which are visible on the product tile
      // should be retrieved
      include_fields:
        'id,product_id,title,slug,brand_name,store_name,label_ids,price_eur,price_gbp,price_usd,price_cad,price_old_eur,price_old_gbp,price_old_usd,price_old_cad,discounted,fair_fashion_giftcard,interaction_rate_rounded,favorites_rounded,outlink_clicks_rounded,store_membership,full_image_flag,main_image_aspect_ratio,main_image_url,main_image_urls_default_default,main_image_urls_default_webp,main_image_urls_big_default,main_image_urls_big_webp',
      // We don't do highlighting (yet), and this prevents loading
      // a lot of extra (text) data
      highlight_fields: 'none',
    },
  });
  const searchClient = typesenseInstantsearchAdapter.searchClient;

  const router = createRouter();

  const app = new Vue({
    store,
    router,
    mixins: [
      createServerRootMixin({
        searchClient,
        indexName: store.state.typesense.collectionName,
        routing: {
          router: routing.createRouter({
            context,
            store,
            router,
            indexName: store.state.typesense.collectionName,
          }),
        },
      }),
    ],
    serverPrefetch() {
      return this.instantsearch.findResultsState({
        component: this,
        renderToString,
      });
    },
    created() {
      // const self = this;
      // if (typeof window === 'object') {
      //   if (window.cookies.hasConsent(window.cookies.CONSENT_MARKETING)) {
      //     initAnalytics();
      //   } else {
      //     window.cookies.addEventListener(
      //       'consent',
      //       function ({ detail: { levels } }) {
      //         if (levels.includes(window.cookies.CONSENT_MARKETING)) {
      //           initAnalytics();
      //         }
      //       }
      //     );
      //   }
      // }
      // function initAnalytics() {
      //   aa('init', {
      //     appId: context.algolia.applicationID,
      //     apiKey: context.algolia.searchAPIKey,
      //     useCookie: true,
      //   });
      //   // Use our user id als identifier if user is logged in
      //   if (window.account.isAuthenticated()) {
      //     aa('setUserToken', window.account.getUserId().toString());
      //   }
      //   // Because queryID isn't always set, which seems to be a bug
      //   // we create our own insights middleware here so that we can
      //   // catch the events and add a queryID
      //   // Based on: https://github.com/algolia/vue-instantsearch/issues/888
      //   self.instantsearch.use(
      //     createInsightsMiddleware({
      //       insightsClient: aa,
      //       onEvent: (event, aa) => {
      //         const { insightsMethod, payload } = event;
      //         // For a magical reason do the default automatically send events
      //         // of Algolia don't have a queryID (even though click-analytics
      //         // is set to true on ais-configure...)
      //         // So here we set the last queryID we know manually
      //         if (!payload.queryID && store.state.algolia.queryID) {
      //           payload.queryID = store.state.algolia.queryID;
      //         }
      //         aa(insightsMethod, payload);
      //       },
      //     })
      //   );
      // }
    },
    beforeMount() {
      if (typeof window === 'object' && window.__ALGOLIA_STATE__) {
        this.instantsearch.hydrate(window.__ALGOLIA_STATE__);
        delete window.__ALGOLIA_STATE__;
      }
    },
    render(createElement) {
      return createElement(App);
    },
  });

  return { app, router };
}
